import {createClient} from '@sanity/client'
import imageUrlBuilder from '@sanity/image-url'

export const sanityClient = createClient({
  projectId: process.env.REACT_APP_SANITY_PROJECT_ID,
  dataset: process.env.REACT_APP_SANITY_DATASET || 'production',
  apiVersion: process.env.REACT_APP_SANITY_API_VERSION || '2024-01-01',
  // Không gửi token: dataset đọc công khai, và mọi biến REACT_APP_* đều bị nhúng
  // vào bundle JS công khai. Bỏ token còn giúp tránh CORS preflight và cho phép
  // dùng API CDN (apicdn), rút ngắn thời gian tải dữ liệu trang chủ.
  useCdn: true,
  perspective: 'published',
})

const builder = imageUrlBuilder(sanityClient)

// auto('format'): Sanity CDN trả WebP/AVIF khi trình duyệt hỗ trợ thay vì PNG gốc.
// quality(90): giữ ảnh sắc nét, tránh vỡ nét trên màn hình độ phân giải cao.
export const urlFor = (source) => builder.image(source).auto('format').quality(90)
